class StickyHeader extends HTMLElement {
  constructor() {
    super();

    [this.container] = this.children;
    console.log('sitck header')
  }

  connectedCallback() {
    this.checkScroll();

    window.addEventListener('scroll', this.checkScroll.bind(this));
  }

  checkScroll() {
    if (window.scrollY > 120) {
      console.log('scroll')
      this.container.classList.add('scrolled');
    } else {
      this.container.classList.remove('scrolled');
    }
  }
}

customElements.define('sticky-header', StickyHeader);
